//@ts-ignore
import React, { useState, useEffect } from "react";
import _ from "lodash";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import ReportsContainer from "./ReportsContainer";
import QuestionIssueReport from "./QuestionIssueReport";
import { REPORT_MENU } from "./ReportsServices";
import ACLService from "../../acl/services/aclService";
import { MODULES, USER_RIGHTS } from "../../../constants/comman";

interface ReportsMenuProps extends WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    header: {
      display: "flex",
      color: "#333",
      fontFamily: "Nunito",
      fontSize: "36px",
      fontWeight: 400,
    },
    body: {
      display: "flex",
      flexDirection: "column",
      marginTop: "120px",
    },
    subHeading: {
      display: "flex",
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: "32px",
    },
    reportBox: {
      display: "flex",
      marginLeft: "auto",
      marginRight: "auto",
      fontFamily: "Nunito",
      fontSize: "18px",
      fontWeight: 400,
    },
    createBox: {
      width: "338px",
      height: "172px",
      borderRadius: "8px",
      border: "1px solid #E6E6E6",
      background: "#FFF",
      cursor: "pointer",
      marginRight: "30px",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      padding: "37px 32px",
    },
    IssueBox: {
      width: "338px",
      height: "172px",
      borderRadius: "8px",
      border: "1px solid #E6E6E6",
      background: "#FFF",
      cursor: "pointer",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      padding: "37px 32px",
    },
    name: {
      margin: "auto",
    },
  });

const ReportsMenu = (props: ReportsMenuProps) => {
  const [pageToOpen, setPageToOpen] = useState(REPORT_MENU.HOME);
  const { classes } = props;
  const openReportPage = (page: string) => {
    setPageToOpen(page);
  };

  const questionCreationAccess = ACLService.checkModulePermission(MODULES.EDP_QUESTION_CREATE_REPORT, USER_RIGHTS.DOWNLOAD);
  const questionIssueAccess = ACLService.checkModulePermission(MODULES.EDP_QUESTION_ISSUE_REPORT, USER_RIGHTS.DOWNLOAD);
  const showAllReports = (questionCreationAccess && questionIssueAccess);
  useEffect(() => {
    if (questionCreationAccess && questionIssueAccess) {
      setPageToOpen(REPORT_MENU.HOME);
    } else if (questionCreationAccess) {
      setPageToOpen(REPORT_MENU.QUESTION);
    } else {
      setPageToOpen(REPORT_MENU.ISSUE);
    }
  }, [])

  return (
    <>
      {pageToOpen === REPORT_MENU.HOME && (
        <>
          <div className={classes.header}>Reports</div>
          <div className={classes.body}>
            <div className={classes.subHeading}>Select Type of Report</div>
            <div className={classes.reportBox}>
              <div
                className={classes.createBox}
                onClick={() => openReportPage(REPORT_MENU.QUESTION)}
              >
                <img
                  src="/assets/svg/creation-report.svg"
                  alt="Create Report"
                  className={classes.name}
                />
                <div className={classes.name}>Question Creation Report</div>
              </div>
              <div
                className={classes.IssueBox}
                onClick={() => openReportPage(REPORT_MENU.ISSUE)}
              >
                <img
                  src="/assets/svg/issue-report.svg"
                  alt="Issue Report"
                  className={classes.name}
                />
                <div className={classes.name}>Question Issues Report</div>
              </div>
            </div>
          </div>
        </>
      )}
      {pageToOpen === REPORT_MENU.QUESTION && <ReportsContainer showBackButton={showAllReports} />}
      {pageToOpen === REPORT_MENU.ISSUE && <QuestionIssueReport showBackButton={showAllReports} />}
    </>
  );
};

export default withStyles(styles)(ReportsMenu);
